module.exports = __webpack_public_path__ + "img/naradie.e9f26b07.svg";